/**
 * Video Player Lazy Loader
 * Lädt plyr-video.js nur wenn Videos auf der Seite vorhanden sind
 * Einsparung: 505KB auf Seiten ohne Videos
 */

window.VideoLazyLoader = {

  /**
   * Prüft ob Videos auf der Seite vorhanden sind
   * @returns {boolean} True wenn Videos gefunden
   */
  hasVideos: function () {
    // Suche nach verschiedenen Video-Elementen
    const videoSelectors = [
      'video',
      '[data-media-type="video"]',
      '[data-media-type="external_video"]',
      '.media-with-text__video',
      '.product-media--video',
      '.plyr',
      '[data-plyr]'
    ];

    for (let selector of videoSelectors) {
      if (document.querySelector(selector)) {
        return true;
      }
    }

    return false;
  },

  /**
   * Lädt den Video Player dynamisch
   */
  loadVideoPlayer: function () {
    return new Promise((resolve, reject) => {
      // Prüfe ob bereits geladen
      if (window.Plyr) {
        resolve();
        return;
      }

      // Erstelle Script-Tag
      const script = document.createElement('script');
      script.src = window.PLYR_VIDEO_URL ||
        (window.Shopify?.routes?.root ?
          window.Shopify.routes.root + 'assets/plyr-video.js' :
          '/assets/plyr-video.js');
      script.async = true;

      script.onload = () => {
        resolve();
      };

      script.onerror = () => {
        console.error('❌ Failed to load video player');
        reject(new Error('Failed to load video player'));
      };

      document.head.appendChild(script);
    });
  },

  /**
   * Initialisiert Videos nach dem Laden des Players
   */
  initializeVideos: function () {
    // Warte kurz bis Plyr verfügbar ist
    setTimeout(() => {
      if (window.Plyr) {
        // Initialisiere alle Video-Player
        const players = new Plyr('.plyr', {
          // Standard Plyr-Konfiguration
          controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
          hideControls: true,
          clickToPlay: true
        });
      }
    }, 100);
  },

  /**
   * Hauptfunktion - Prüft und lädt Videos bei Bedarf
   */
  init: function () {
    // Prüfe sofort nach DOM-Load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.checkAndLoad();
      });
    } else {
      this.checkAndLoad();
    }

    // Prüfe auch nach dynamischen Inhalten (AJAX, etc.)
    this.observeChanges();
  },

  /**
   * Prüft und lädt Videos
   */
  checkAndLoad: function () {
    if (this.hasVideos()) {
      this.loadVideoPlayer()
        .then(() => {
          this.initializeVideos();
        })
        .catch(error => {
          console.error('Video player loading failed:', error);
        });
    }
  },

  /**
   * Beobachtet DOM-Änderungen für dynamisch geladene Videos
   */
  observeChanges: function () {
    if (!window.MutationObserver) return;

    const observer = new MutationObserver((mutations) => {
      let hasNewVideos = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Prüfe ob neue Videos hinzugefügt wurden
              const videoSelectors = ['video', '[data-media-type="video"]', '[data-media-type="external_video"]'];
              for (let selector of videoSelectors) {
                if (node.matches && node.matches(selector) || node.querySelector && node.querySelector(selector)) {
                  hasNewVideos = true;
                  break;
                }
              }
            }
          });
        }
      });

      if (hasNewVideos && !window.Plyr) {
        this.checkAndLoad();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};

// Auto-Initialize
VideoLazyLoader.init();
